import React from 'react';
// Constants
import {
  CompanyName,
  CompanyTagLine,
  CONTACT_PAGE_URL,
  GALLERY_PAGE_URL,
  SubtitleMain,
} from '../../utils/Constants';
// Images
import MainImage from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-tits-boot-crush.jpg';
// Data
import { smallSocialMediaPins } from '../../utils/data/LinksData';

function HomePageHeader() {
  return (
    <header className='grid h-full w-full'>
      <div className='grid w-full pt-16 lg:pt-24 px-4 sm:px-6 md:px-12 lg:container lg:mx-auto gap-y-4'>
        <article className='grid gap-6 text-center'>
          <div className='flex items-center justify-center'>
            <span className='glowing-dot'></span>
            <h3 className='text-colour7 dark:text-colour7 text-sm sm:text-lg md:text-xl font-semibold'>
              AVAILABLE NOW FOR SESSIONS
            </h3>
          </div>
          {/* Header */}
          <section className='grid h-fit gap-y-6 lg:gap-y-12 lg:pt-2 max-w-2xl mx-auto'>
            <h1 className='text-4xl xs:text-[2.9rem] md:text-6xl lg:text-7xl xl:text-8xl font-titleFont text-colour7'>
              {CompanyName}
            </h1>
            <div className='grid h-fit gap-y-4'>
              <h2 className='tracking-widest text-sm lg:text-2xl leading-5'>
                {SubtitleMain}
              </h2>
              <h3 className='tracking-widest text-sm lg:text-2xl leading-5'>
                {CompanyTagLine}
              </h3>
            </div>
          </section>
          {/* Image */}
          <section className='grid'>
            <div className='z-10 px-8 xs:px-10 xs:py-5'>
              <img
                src={MainImage}
                alt={`${CompanyName} with neon diamond logo`}
                className='mx-auto sm:max-w-[60vw] md:max-h-[60vh] rounded neon_shadow'
                loading='lazy'
              />
            </div>
          </section>
          {/* Cta */}
          <div className='grid h-fit gap-y-2 pt-4 px-8 md:grid-cols-2 gap-x-4 max-w-2xl mx-auto w-full'>
            <div className='grid w-full'>
              <a
                href={CONTACT_PAGE_URL}
                aria-label='Contact Me to serve Me now'
                className={`cursor-pointer border-2 border-solid w-full border-colour7 py-1 bg-colour8 hover:bg-transparent active:scale-95 duration-200 transition`}
              >
                SERVE ME
              </a>
            </div>
            <div className='grid w-full'>
              <a
                href={GALLERY_PAGE_URL}
                aria-label='Contact Me to serve Me now'
                className={`cursor-pointer border-2 border-solid w-full border-colour8 py-1 hover:bg-colour8 hover:text-colour1 hover:border-colour1 active:scale-95 duration-200 transition`}
              >
                SEE MORE
              </a>
            </div>
          </div>
        </article>
        <section className='grid gap-y-2 w-fit mx-auto py-4'>
          <div className='text-center'>
            <p>Find Me On</p>
          </div>
          <div className='grid grid-flow-col items-center gap-4 lg:gap-6'>
            {smallSocialMediaPins.map((pin) => (
              <a
                key={pin.serviceName}
                href={pin.url}
                className=''
                aria-label={`${CompanyName} social media link for ${pin.serviceName}`}
                target='_blank'
                rel='noreferrer'
              >
                <div className='grid items-center justify-center text-xl lg:text-3xl'>
                  {pin.icon}
                </div>
              </a>
            ))}
          </div>
        </section>
      </div>
    </header>
  );
}

export default HomePageHeader;
